const WORK_VUETIFY_ICON_SET = Object.freeze({
  wAccessConfig: { component: 'w-icon-access-config' },
  wAdd: { component: 'w-icon-add' },
  wApplicationReject: { component: 'w-icon-application-reject' },
  wApplicationReopen: { component: 'w-icon-application-reopen' },
  wArchived: { component: 'w-icon-archived' },
  wArrowDown: { component: 'w-icon-arrow-down' },
  wAttention: { component: 'w-icon-attention' },
  wBack: { component: 'w-icon-back' },
  wBulkExecuteSelection: { component: 'w-icon-bulk-execute-selection' },
  wBusinessTrip: { component: 'w-icon-business-trip' },
  wCalculation: { component: 'w-icon-calculation' },
  wCalendar: { component: 'w-icon-calendar' },
  wCall: { component: 'w-icon-call' },
  wCamera: { component: 'w-icon-camera' },
  wCar: { component: 'w-icon-car' },
  wCheck: { component: 'w-icon-check' },
  wCheckboxIndeterminate: { component: 'w-icon-checkbox-indeterminate' },
  wCheckmark: { component: 'w-icon-checkmark' },
  wCheckboxSelect: { component: 'w-icon-checkbox-select' },
  wCheckboxUnselect: { component: 'w-icon-checkbox-unselect' },
  wCheckboxSelectAll: { component: 'w-icon-checkbox-select-all' },
  wCheckboxMinus: { component: 'w-icon-checkbox-minus' },
  wCircle: { component: 'w-icon-circle' },
  wClose: { component: 'w-icon-close' },
  wCollapse: { component: 'w-icon-collapse' },
  wColorNoSelection: { component: 'w-icon-color-no-selection' },
  wColorSelection: { component: 'w-icon-color-selection' },
  wCompany: { component: 'w-icon-company' },
  wCompanyAdd: { component: 'w-icon-company-add' },
  wConfirmDeviation: { component: 'w-icon-confirm-deviation' },
  wContainer: { component: 'w-icon-container' },
  wCopyContact: { component: 'w-icon-copy-contact' },
  wCopyProject: { component: 'w-icon-copy-project' },
  wCreateBill: { component: 'w-icon-create-bill' },
  wCustomer: { component: 'w-icon-customer' },
  wDashboard: { component: 'w-icon-dashboard' },
  wDelete: { component: 'w-icon-delete' },
  wDemand: { component: 'w-icon-demand' },
  wDeputy: { component: 'w-icon-deputy' },
  wDocument: { component: 'w-icon-document' },
  wDocumentAdd: { component: 'w-icon-document-add' },
  wDocumentPlus: { component: 'w-icon-document-plus' },
  wDown: { component: 'w-icon-down' },
  wDownload: { component: 'w-icon-download' },
  wDownloadCsv: { component: 'w-icon-download-csv' },
  wDownloadExcel: { component: 'w-icon-download-excel' },
  wDownloadZip: { component: 'w-icon-download-zip' },
  wDunning: {component: 'w-icon-dunning'},
  wEdit: { component: 'w-icon-edit' },
  wEditModeOff: { component: 'w-icon-edit-mode-off' },
  wEditModeOn: { component: 'w-icon-edit-mode-on' },
  wEditView: { component: 'w-icon-edit-view' },
  wElectricMagnifier: { component: 'w-icon-electric-magnifier' },
  wEmail: { component: 'w-icon-email' },
  wEquals: { component: 'w-icon-equals' },
  wExport: { component: 'w-icon-export' },
  wExportMessage: { component: 'w-icon-export-message' },
  wFavorite: { component: 'w-icon-favorite' },
  wFavoriteFilled: { component: 'w-icon-favorite-filled' },
  wFilter: { component: 'w-icon-filter' },
  wFilterAdd: { component: 'w-icon-filter-add' },
  wFilterSelect: { component: 'w-icon-filter-select' },
  wGlobalSearch: { component: 'w-icon-global-search' },
  wGreaterThan: { component: 'w-icon-greater-than' },
  wHamburgerMenu: { component: 'w-icon-hamburger-menu' },
  wHelp: { component: 'w-icon-help' },
  wHistory: { component: 'w-icon-history' },
  wImport: { component: 'w-icon-import' },
  wInfo: { component: 'w-icon-info' },
  wInitialAssessment: { component: 'w-icon-initial-assessment' },
  wInspection: { component: 'w-icon-inspection' },
  wKey: { component: 'w-icon-key' },
  wLink: { component: 'w-icon-link' },
  wLock: { component: 'w-icon-lock' },
  wLocked: { component: 'w-icon-locked' },
  wLogout: { component: 'w-icon-logout' },
  wMessageAdd: { component: 'w-icon-message-add' },
  wMinus: { component: 'w-icon-minus' },
  wMobilePhone: { component: 'w-icon-mobile-phone' },
  wModuleOverview: { component: 'w-icon-module-overview' },
  wMoveProject: { component: 'w-icon-move-project' },
  wMoveable: { component: 'w-icon-moveable' },
  wNavActivities: { component: 'w-icon-nav-activities' },
  wNavCollapse: { component: 'w-icon-nav-collapse' },
  wNavContacts: { component: 'w-icon-nav-contacts' },
  wNavDevices: { component: 'w-icon-nav-devices' },
  wNavEmployees: { component: 'w-icon-nav-employees' },
  wNavExpand: { component: 'w-icon-nav-expand' },
  wNavHolidays: { component: 'w-icon-nav-holidays' },
  wNavInvoice: { component: 'w-icon-nav-invoice' },
  wNavMonth: { component: 'w-icon-nav-month' },
  wNavNotification: { component: 'w-icon-nav-notification' },
  wNavOfficialHolidays: { component: 'w-icon-nav-official-holidays' },
  wNavOrdering: { component: 'w-icon-nav-ordering' },
  wNavNavision: { component: 'w-icon-nav-navision' },
  wNavProcessSupport: { component: 'w-icon-nav-process-support' },
  wNavProduct: { component: 'w-icon-nav-product' },
  wNavProjectManagment: { component: 'w-icon-nav-project-managment' },
  wNavReport: { component: 'w-icon-nav-report' },
  wNavSearch: { component: 'w-icon-nav-search' },
  wNavSickNotes: { component: 'w-icon-nav-sick-notes' },
  wNavSystemConfiguration: { component: 'w-icon-nav-system-configuration' },
  wNavWarehouseManagement: { component: 'w-icon-nav-warehouse-management' },
  wNavWorkingTimeManagment: { component: 'w-icon-nav-working-time-managment' },
  wNext: { component: 'w-icon-next' },
  wNotification: { component: 'w-icon-notification' },
  wNotInSync: { component: 'w-icon-not-in-sync' },
  wOptions: { component: 'w-icon-options' },
  wOrdered: { component: 'w-icon-ordered' },
  wOrganizationElement: { component: 'w-icon-organization-element' },
  wOutsideOffice: { component: 'w-icon-outside-office' },
  wPaymentReminder: { component: 'w-icon-paymentReminder' },
  wPlanning: { component: 'w-icon-planning' },
  wPriceUpload: { component: 'w-icon-price-upload' },
  wPrinter: { component: 'w-icon-printer' },
  wProductStorage: { component: 'w-icon-product-storage' },
  wProposal: { component: 'w-icon-proposal' },
  wQrCode: { component: 'w-icon-qr-code' },
  wRadioSelected: { component: 'w-icon-radio-selected' },
  wRadioUnselected: { component: 'w-icon-radio-unselected' },
  wRefresh: { component: 'w-icon-refresh' },
  wRepair: { component: 'w-icon-repair' },
  wReserved: { component: 'w-icon-reserved' },
  wReservedDemand: { component: 'w-icon-reserved-demand' },
  wReset: { component: 'w-icon-reset' },
  wRevertArchived: { component: 'w-icon-revert-archived' },
  wRotate: { component: 'w-icon-rotate' },
  wSave: { component: 'w-icon-save' },
  wScan: { component: 'w-icon-scan' },
  wSearch: { component: 'w-icon-search' },
  wSettings: { component: 'w-icon-settings' },
  wService: { component: 'w-icon-service'},
  wSerialNumber: { component: 'w-icon-serial-number' },
  wSkill: { component: 'w-icon-skill' },
  wSmallerThan: { component: 'w-icon-smaller-than' },
  wStock: { component: 'w-icon-stock' },
  wSync: { component: 'w-icon-sync' },
  wTableLayout: { component: 'w-icon-table-layout' },
  wTag: { component: 'w-icon-tag' },
  wTextBlock: { component: 'w-icon-text-block' },
  wTextBlockAdded: { component: 'w-icon-text-block-added' },
  wTime: { component: 'w-icon-time' },
  wUnfold: { component: 'w-icon-unfold' },
  wUnlink: { component: 'w-icon-unlink' },
  wUniversalStorage: { component: 'w-icon-universal-storage' },
  wUnreadableSerialNumber: { component: 'w-icon-unreadable-serial-number' },
  wUp: { component: 'w-icon-up' },
  wUpload: { component: 'w-icon-upload' },
  wUser: { component: 'w-icon-user' },
  wView: { component: 'w-icon-view' },
  wWarning: { component: 'w-icon-warning' },
  wWeb: { component: 'w-icon-web' },
  wWidget: { component: 'w-icon-widget' },
  wWord: { component: 'w-icon-word' },
  wPdf: { component: 'w-icon-pdf' },
  wWork: { component: 'w-icon-work' },
});

export default WORK_VUETIFY_ICON_SET;
